import styled from 'styled-components';
import { useContext, useEffect, useState } from "react";
import Fade from "components/services/Fade";
import ToolContext from 'components/services/ToolContext';




const RedirectScreen = ({ params }) => {
  // Get the  dialog data
  const tool = useContext(ToolContext)
  const redirect = tool.constants.tool.goto;
  const { image, title, message } = tool.modals.redirect;

  // Show/hide spiiner on dialog 
  const [showSpin, setShowSpin] = useState(false);


  // Download Legacy Design Function
  async function downloadLegacyDesign() {
    try {
      // Parse the URL to extract savekey and ver parameters
      const searchParams = new URLSearchParams(params);
      const savekey = searchParams.get('savekey');
      const ver = searchParams.get('ver');

      if (!savekey) {
        setShowSpin(false);
        setTimeout(() => {
        alert('Error: No savekey found in the URL');
        }, 100)
        return;
      }

      if (!ver) {
        setShowSpin(false);
        setTimeout(() => {
        alert('Error: No ver (version) found in the URL');
        }, 100)
        return;
      }

      console.log('Parsed parameters:', { savekey, ver });
      console.log('Downloading legacy design from server...');

      // Download the design directly from the server (handles multi-area splitting automatically)
      // Note: This is a public endpoint, no auth required
      const response = await fetch('https://designer-storage-api-prod.azurewebsites.net/api/v1/designs/downloadlegacy', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify({
          savekey: savekey,
          ver: ver
        })
      });

      if (!response.ok) {
        const errorData = await response.json();
        throw new Error(errorData.error || `Failed to download legacy design: ${response.status} ${response.statusText}`);
      }

      // Get the filename from the response headers
      const contentDisposition = response.headers.get('Content-Disposition');
      let filename = `legacy_${savekey}_v${ver}.bwd`;
      if (contentDisposition) {
        const filenameMatch = contentDisposition.match(/filename="(.+)"/);
        if (filenameMatch) {
          filename = filenameMatch[1];
        }
      }

      // Create a blob from the response and trigger download
      const blob = await response.blob();
      const downloadUrl = window.URL.createObjectURL(blob);
      const a = document.createElement('a');
      a.href = downloadUrl;
      a.download = filename;
      document.body.appendChild(a);
      a.click();
      window.URL.revokeObjectURL(downloadUrl);
      document.body.removeChild(a);

      console.log('Successfully downloaded:', filename);
      setTimeout(() => {
        alert(`Successfully downloaded legacy design!\nFilename: ${filename}`);
        handleRedirect();
      }, 100)

    } catch (error) {
      console.error('Error downloading legacy design:', error);
      setTimeout(() => {
      alert(`Error: ${error.message}`);
      }, 100)
    }

    // Hide rhe sppinner
    setShowSpin(false);
  }

  const handleClick = () => {
    setShowSpin(true);
    downloadLegacyDesign();
  };

  // Don't download and simply redirect 
  const handleRedirect = () => {
    // Clear all storage
    sessionStorage.clear();
    localStorage.clear();

    // Force hard reload and redirect
    window.location.replace(redirect + '?_=' + Date.now());

  };

  useEffect(() => { 
    console.log("showSpin: ", showSpin);
  }, [showSpin]);



  return (
    <Fade className={'h-100'} duration={'slow'} show={true} callback={() => { }}>
      <RedirectScreen.Background image={image}>
        <RedirectScreen.Content>
          <RedirectScreen.Title>{title}</RedirectScreen.Title>
          <RedirectScreen.Message>
          <RedirectScreen.Text showSpin={showSpin}>{message}</RedirectScreen.Text>
          <RedirectScreen.Spin showSpin={showSpin}/>
          </RedirectScreen.Message>
          <RedirectScreen.Buttons>
            <RedirectScreen.Button secondary onClick={handleRedirect} >Continue Without Downloading</RedirectScreen.Button>
            <RedirectScreen.Button primary onClick={handleClick}>Download Design</RedirectScreen.Button>
          </RedirectScreen.Buttons>
        </RedirectScreen.Content>
      </RedirectScreen.Background>
    </Fade>
  )
};

RedirectScreen.Background = styled.div.attrs(props => ({
  className: 'container-medium h-100 d-flex align-items-center justify-content-center',
}))`
background-image: url(${props => props.image});
background-size: cover;
background: ${props => !props.image && 'rgba(255, 255, 255, 0.5)'};
z-index: 1;
`;

RedirectScreen.Content = styled.div.attrs(props => ({
  className: 'modal-content',
}))`
  background-color: #fff;
  width: 850px;
  height: fit-content;
  border-radius: 12px;
  border: 1px solid rgba(17, 17, 17, 0.15);
  color: #000;
  padding: 24px;
`;

RedirectScreen.Title = styled.h2.attrs(props => ({
  className: 'redirect'
}))`
  font-family: montserrat;
  font-size: 24px;
  font-weight: 600;
`

RedirectScreen.Message = styled.div.attrs(props => ({
  className: 'modal-content mx-auto mt-3 d-flex align-items-center justify-content-center',
}))`
`

RedirectScreen.Text = styled.span.attrs(props => ({
  className: ''
}))`
  white-space: pre-line;
  font-family: montserrat;
  font-size: 18px;
  color: ${props => props.showSpin ? '#aaa' : '#000'}
`

RedirectScreen.Spin = styled.span.attrs(props => ({
  className: 'spinner-border',
  role: 'status'
}))`
  visibility: ${props => props.showSpin ? 'visible' : 'hidden'};
  position: absolute;
  color: #000;
  width: 6rem;
  height: 6rem;
  border-width: .2rem
`;

RedirectScreen.Buttons = styled.div.attrs(props => ({
  className: 'modal-content mt-5 mx-auto d-flex flex-row justify-content-between',
}))`
`

RedirectScreen.Button = styled.button.attrs(props => ({
  className: `h-auto p-2 rounded-1`
}))`
  width: 49%;
  border: 1px solid rgba(17, 17, 17, 0.4);
  border-radius: 6px;
  Background-color: ${props => props.primary ? '#1863D3' : '#fff'};
  color: ${props => props.primary ? '#fff' : '##000'}

`

export default RedirectScreen;
